import { ObjectLabel } from 'app/providers/storage-api/object-label.service';

export type DataSourceType = 'analysis' | 'group';

export class WidgetDataSource {
  id: string;
  analysisId: string;
  groupId?: string;
  displayName: string;
  type: DataSourceType;
  collectionName: string;
  collectionDisplayName?: string;
  groupCollections?: string[];
  groupAnalyses?: string[];
  entityTypes?: string[];
  topicTypes?: string[];
  modifiedAt?: Date;
  createdAt?: Date;
  hasDateData?: boolean;
  hasTaxonomy?: boolean;
  version?: number;
  documentCount?: number;
  unfilteredDocumentCount?: number;
  tooltip?: string;
  customFields?: string[];
  standardFields?: string[];
  calculatedFields?: string[];
  hasEntities?: boolean;
  hasPhrases?: boolean;
  hasThemes?: boolean;
  hasTopics?: boolean;
  hasTopicMentions?: boolean;
  hasTopicPhrases?: boolean;
  hasTopicThemes?: boolean;
  hasThemeMentions?: boolean;
  hasEntityMentions?: boolean;
  hasEntityPhrases?: boolean;
  sourceVersion?: number;
  minDocAt?: Date;
  maxDocAt?: Date;
  isFinished?: boolean;
  isAutoAnalyze?: boolean;
  clauseModelTypes?: string[];
  configName?: string;
  configId?: string;
  configLanguage?: string;
  isDriverAnalysis?: boolean;
  tags?: string[];
  notes?: string;
  query?: string;
  hasSections?: boolean;
  sectionFieldNames?: string[];
  embeddingStatus?: string;
  embeddingModel?: string;
  embeddingStrategy?: string;
  isSocial?: boolean;
  unAliasedCustomFields?: string[];
  unAliasedWeightFields?: any[];
  contentChannel?: string;
  objectLabels?: string[] | ObjectLabel[];
  hasSectionSentiment?: boolean;
  sectionPropertyTypes?: string[];
  isJourneyGroup?: boolean;
  journeyGroupRule?: { defaultField: string; resolvedFields: string[] };
}
